import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteSupervisoryInstitutionOperation = async (
  supervisoryInstitutionId: number,
  setDeleteSupervisoryInstitutionId: (majorId: number | null) => any,
) => {
  try {
    setDeleteSupervisoryInstitutionId(supervisoryInstitutionId);

    const res = await appApi.deleteSupervisoryInstitution(
      supervisoryInstitutionId,
    );

    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }

    setDeleteSupervisoryInstitutionId(null);
  } catch (e) {
    console.error(
      `deleteSupervisoryInstitutionOperation is failed with the supervisoryInstitutionId: ${supervisoryInstitutionId} and the error: ${e}`,
    );
    setDeleteSupervisoryInstitutionId(null);
  }
};
